const initialState = {
  serverTimeDelta: 0,
};

const serverTimeReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SERVER_TIME_DELTA':
      return {
        ...state,
        serverTimeDelta: action.payload,
      };
    default:
      return state;
  }
};

export default serverTimeReducer;
